import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { checkTcAcceptance, acceptTc } from "../api";
import { toast } from "react-toastify";

function TcAcceptanceModal({ show, onHide, company_id, onAccepted }) {
  const [tcDetails, setTcDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [accepted, setAccepted] = useState(false);

  useEffect(() => {
    if (show && company_id) {
      checkTcStatus();
    }
  }, [show, company_id]);

  const checkTcStatus = async () => {
    const response = await checkTcAcceptance(company_id);
    if (response && response.code === 1) {
      if (response.data.needsAcceptance) {
        setTcDetails(response.data.tcDetails);
      } else {
        onHide();
      }
    }
  };

  const handleAccept = async () => {
    if (!accepted) {
      toast.error("Please accept the terms and conditions");
      return;
    }

    setLoading(true);
    const response = await acceptTc(company_id, tcDetails.version);
    setLoading(false);

    if (response && response.code === 1) {
      toast.success("Terms and conditions accepted successfully");
      onAccepted && onAccepted();
      onHide();
    } else {
      toast.error(response?.message || "Failed to accept terms and conditions");
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton={false}>
        <Modal.Title>Terms and Conditions - Version {tcDetails?.version}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">
          <div className="d-flex align-items-center justify-content-center mb-3">
            <input
              type="checkbox"
              id="acceptTc"
              checked={accepted}
              onChange={(e) => setAccepted(e.target.checked)}
              className="me-2"
            />
            <label htmlFor="acceptTc">
              I have read and agree to the{" "}
              <span
                onClick={() => {
                  window.open(
                    "/terms-and-condition/signup for new account",
                    "_blank",
                    "noopener,noreferrer"
                  );
                }}
                style={{ color: '#2c58ab', textDecoration: 'underline', cursor: 'pointer' }}
              >
                terms and conditions
              </span>
            </label>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button
          className="btn btn-create-profile shadow fw-bold"
          style={{ backgroundColor: '#2c58ab', borderColor: '#2c58ab', color: '#ffffff' }}
          onClick={handleAccept}
          disabled={!accepted || loading}
        >
          {loading ? "Accepting..." : "Accept"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default TcAcceptanceModal;
